module.exports = __webpack_public_path__ + "static/media/surfing.1536d4a8.webp";